import { render, staticRenderFns } from "./project_list.vue?vue&type=template&id=19f031dc&scoped=true&"
import script from "./project_list.vue?vue&type=script&lang=js&"
export * from "./project_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f031dc",
  null
  
)

export default component.exports